import { render, staticRenderFns } from "./right-top.vue?vue&type=template&id=6979cc79&scoped=true&"
import script from "./right-top.vue?vue&type=script&lang=js&"
export * from "./right-top.vue?vue&type=script&lang=js&"
import style0 from "./right-top.vue?vue&type=style&index=0&id=6979cc79&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6979cc79",
  null
  
)

export default component.exports